module.exports = __webpack_public_path__ + "img/mail-light.69fca6bd.svg";